
import { useState } from "react";
import { CorpBusinessAccount } from "redmond";
import { PATH_HOME } from "@capone/common";
import { changeBusinessInUse } from "b2b-base/src/api/v1/multi-account/changeBusinessInUse";
import { recentlyViewedAxiosCancelToken } from "b2b-base/src/api/config";
import { useShowMultiAccountSwitcherModal } from "./useShowMultiAccountSwitcherModal";

export const useSwitchBusinessAccount = () => {
  const { setHasSeenMultiAccountsSwitcherModal } =
    useShowMultiAccountSwitcherModal();
  const [isAccountSwitchLoading, setIsAccountSwitchLoading] = useState(false);

  const handleChangeBusinessInUse = (selectedAccount: CorpBusinessAccount) => {
    setIsAccountSwitchLoading(true);
    setHasSeenMultiAccountsSwitcherModal("true");
    if (selectedAccount?.optedIn) {
      recentlyViewedAxiosCancelToken.cancel();
      changeBusinessInUse({
        businessId: selectedAccount.optedIn.businessId,
      })
        .then((response) => {
          setIsAccountSwitchLoading(false);
          window.location.href = response.request.responseURL;
        })
        .catch(() => {
          setIsAccountSwitchLoading(false);
        });
    } else {
      window.location.replace(PATH_HOME);
    }
  };

  return {
    handleChangeBusinessInUse,
    isAccountSwitchLoading,
  };
};
